import NostosExternalGetDataDocument from 'bundles/nostos-external/NostosExternalGetData.graphql';
import type {
  NostosExternalGetDataQuery as NostosExternalGetDataQueryResponse,
  NostosExternalGetDataQueryVariables,
} from 'bundles/nostos-external/__generated__/NostosExternalGetData';

/**
 * Query against the Nostos v3 external API, federated into the GraphQL gateway
 * (`context: { clientName: 'gatewayGql' }` is required — the field only exists on
 * the gateway schema).
 *
 * Column values are raw JSON strings (the server does no parsing); use the
 * per-table adapters in `bundles/nostos-external/adapters` to convert entries into
 * the `{ id, content }` element shape components consume.
 */
export const NostosExternalGetDataQuery = NostosExternalGetDataDocument;

export type { NostosExternalGetDataQueryVariables };

export type NostosExternalGetDataQueryType = NostosExternalGetDataQueryResponse;

export type NostosExternalEntry = NonNullable<
  NonNullable<NostosExternalGetDataQueryType['NostosExternal']>['getData']
>['entries'][number];

export type NostosExternalColumnData = NostosExternalEntry['data'][number];
